import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader'
import moment from 'moment'
import CustomizedTextField from '../../Input/CustomizedTextField';

class AffairCard extends Component {

    render() {

        return (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                <Card className="card without-padding card-margin-top">
                    <CardHeader style={{ color: 'rgb(117, 117, 117)' }} title={this.props.currentAffair.name}
                        className="card-header-padding-bottom" />
                    <CardContent className="without-padding card-content-left-align">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="affair-code"
                                label="Code"
                                className="full_size light-disabled"
                                value={this.props.currentAffair.code}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="company_name"
                                label="Agence"
                                className="full_size light-disabled"
                                value={this.props.currentAffair.company_id.name}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="state"
                                label="Statut"
                                className="full_size light-disabled"
                                value={this.props.currentAffair.state}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="start-date"
                                label="Date de début"
                                className="full_size light-disabled"
                                value={moment(this.props.currentAffair.date_start, "YYYY-MM-DD").format("DD/MM/YYYY")}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="end-date"
                                label="Date de fin"
                                className="full_size light-disabled"
                                value={moment(this.props.currentAffair.date_end, "YYYY-MM-DD").format("DD/MM/YYYY")}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="business-user"
                                label="Commercial"
                                className="full_size light-disabled"
                                value={this.props.currentAffair.business_user_id.name}
                            />
                        </div>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

export default withRouter(AffairCard);
